// extracted by mini-css-extract-plugin
export var active = "_7y-b";
export var activeIndicator = "_7y-6";
export var animate = "_7y-a";
export var disabled = "_7y-c";
export var flat = "_7y-1";
export var fullWidth = "_7y-3";
export var lg = "_7y-9";
export var md = "_7y-8";
export var redoButtonTabGroup = "_7y-0";
export var sm = "_7y-7";
export var tabButton = "_7y-4";
export var tabButtonsContainer = "_7y-2";
export var xs = "_7y-5";